/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/** Required for Safari compatibility (ES6+ features) */
import 'core-js/es/reflect'; // Polyfill for older JavaScript features
import 'core-js/stable'; // Ensures full polyfill for Safari < 15

/** Zone.js is required by Angular itself */
//import 'zone.js'; // Included with Angular

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/** Enable support for internationalization of dates, numbers, and currencies */
//import '@angular/localize/init';
